
import { defineComponent, ref, computed, onMounted, getCurrentInstance } from 'vue';
import { getQuery, roundingNum } from '@/common/utils';
import { sendLog } from '@/common/radar';

export default defineComponent({
    components: {},
    props: {
        imgSrc: {
            type: String,
            // required: true,
            default: '',
        },
        headUrl: {
            type: String,
            // required: true,
            default: 'https://cdn-static.kwai.net/kos/s101/nlav11312/kwai-share/s1/i/def/head_m.png',
        },
        viewCount: {
            type: Number,
            required: true,
            default: 0,
        },
        likeCount: {
            type: Number,
            required: true,
            default: 0,
        },
        forwardCount: {
            type: Number,
            required: true,
            default: 0,
        },
        commentCount: {
            type: Number,
            required: true,
            default: 0,
        },
        userId: {
            type: Number,
            required: true,
            default: 0,
        },
        index: {
            type: Number,
            required: true,
            default: 0,
        },
        photoId: {
            type: String,
            required: true,
        },
        kwaiId: {
            type: String,
            required: true,
        },
        userName: {
            type: String,
            default: '',
            required: true,
        },
        caption: {
            type: String,
            required: true,
            default: '',
        },
    },
    setup(props) {
        const { proxy } = getCurrentInstance() as any;
        const origin = ref('');
        const query = getQuery();

        const logParams = computed(() => {
            return {
                author_id: props?.userId,
                photo_id: props?.photoId,
                like: props?.likeCount,
                play: props?.viewCount,
                comment: props?.commentCount,
                share: props?.forwardCount,
                card_type: 'photo_small',
            };
        });

        const handleClick = () => {
            sendLog({
                type: 'click',
                name: 'PHOTO_COVER',
                value: {
                    ...logParams.value,
                },
            });
            proxy.$router.push({ path: jumpPhotoLink.value, query: { ...query, page_source: 'discover' } });
        };

        const formateCaption = computed(() => {
            return props.caption === '...' ? proxy.$root.$t('k_467928') : props.caption;
        });

        const jumpPhotoLink = computed(() => {
            return `/@${props.kwaiId}/video/${props.photoId}`;
        });

        const jumpUserLink = computed(() => {
            return `/@${props.kwaiId}`;
        });

        const handleHeaderClick = () => {
            sendLog({
                type: 'click',
                name: 'PHOTO_CARD_SPECIAL',
                value: {
                    button_type: 'author_icon',
                    card_type: 'photo_small',
                },
            });
            proxy.$router.push({ path: jumpUserLink.value, query: { ...query, page_source: 'discover' } });
        };

        onMounted(() => {
            origin.value = window.location.origin;
        });

        return {
            origin,
            jumpPhotoLink,
            jumpUserLink,
            formateCaption,
            logParams,
            handleClick,
            handleHeaderClick,
            roundingNum,
        };
    },
});
